import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  width: 100vw;\n'], ['\n  position: relative;\n  width: 100vw;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  query query {\n    shop {\n      name\n      description\n    }\n  }\n'], ['\n  query query {\n    shop {\n      name\n      description\n    }\n  }\n']);

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Router } from '@reach/router';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import gql from 'graphql-tag';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import styled, { ThemeProvider } from 'styled-components';

import CollectionClient from './collectionClient';
import VisualizerClient from './visualizerClient';

import HomePage from './templates/HomePage';
import CartPage from './templates/CartPage';
import SliderPage from './templates/SliderPage';
import HolidayPage from './templates/HolidayPage';
import ColorPage from './templates/ColorPage';
import DataCapturePage from './templates/DataCapturePage';
import CollectionPage from './templates/CollectionPage';
import ProductPage from './templates/ProductPage';
import DyPage from './templates/DyPage';

import Account from './components/Account/Account';
import AccountVisualizerClient from './components/AccountVisualizer/AccountVisualizerClient';
import DataCaptureModal from './components/DataCaptureModal/DataCaptureModal';
import UscDataCaptureModal from './components/UscDataCaptureModal/UscDataCaptureModal';
import AccountModal from './components/AccountModal/AccountModal';
import AccountBtn from './components/AccountBtn/AccountBtn';
import FooterForm from './components/Form/FooterForm';
import CartDrawer from './components/CartDrawer/CartDrawer';
import CartDrawerAlt from './components/CartDrawerAlt/CartDrawerAlt'; // for AB TEsting
import MobileNav from './components/MobileNav/MobileNav';
import CartBtn from './components/CartBtn/CartBtn';
import CloseButton from './components/CloseBtn/CloseBtn';
import MobileHamburger from './components/MobileHamburger/MobileHamburger';

import { getEncodedVariantId } from './Utils/VariantUtils';
import { getVendorCustomAttribute, addLineItemsToSwym } from './Utils/CartUtils';
import { createCheckout, checkoutLineItemsReplace, checkoutLineItemsUpdate, checkoutLineItemsRemove, checkoutCustomerAssociate, checkoutDiscountCodeApplyV2, checkoutDiscountCodeRemove, checkoutAttributesUpdateV2, addVariantToCart, updateLineItemInCart, removeLineItemInCart, associateCustomerCheckout, updateCartQuantity, addCheckoutNote, addPlusReleaseDate, addDiscountCode, removeDiscountCode } from './checkout';
import { getCookie } from './Utils/FormUtils';

var theme = require('sass-extract-loader?{"plugins": ["sass-extract-js"]}!../../styles/timber/variables.scss');

var StyledAppWrapper = styled.div(_templateObject);

var App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));

    _this.handleGlobalAddToCart = function (variantId, product, foursixtyContext) {
      var encodedVariantId = getEncodedVariantId(variantId);
      var vendorCustomAttribute = getVendorCustomAttribute(product.vendor);
      // create an array of one variant. and pass to addVariantToCartFunc
      var items = [{
        variantId: encodedVariantId,
        quantity: 1,
        customAttributes: vendorCustomAttribute
      }];
      _this.addVariantToCart(items);
      if (foursixtyContext) {
        foursixtyContext.hideBuyForm();
      }
    };

    _this.handleCartOpen = function () {
      disableBodyScroll(document.querySelector('.CartDrawer')); // prevent body scrolling, except CartDrawer
      _this.setState({
        isCartOpen: true
      });
    };

    _this.handleCartClose = function () {
      clearAllBodyScrollLocks(); // reenable body scrolling
      _this.setState({
        isCartOpen: false
      }, function () {
        document.querySelector('.CartDrawer').scrollTo(0, 0);
      });
    };

    _this.handleFormSubmitDiscountCode = function (formOrigin) {
      // If submitted via USC Data Capture Modal
      // apply USC Discount Code.
      var origin = formOrigin === 'usc' ? 'usc' : '';

      _this.setState({
        formSubmitted: true,
        formOrigin: origin
      });
    };

    _this.toggleMobileNav = function () {
      var header = document.querySelector('.header');
      header.classList.toggle('mobile-nav-open');
      _this.setState({
        isNavOpen: !_this.state.isNavOpen
      });
    };

    _this.toggleAccountModal = function (_ref) {
      var active = _ref.active,
          formType = _ref.formType;

      _this.setState({
        isAccountModalOpen: active,
        accountForm: formType
      });
    };

    _this.toggleAccountForm = function (_ref2) {
      var formType = _ref2.formType;

      _this.setState({
        accountForm: formType
      });
    };

    _this.state = {
      isCartOpen: false,
      isNavOpen: false,
      isAccountModalOpen: false,
      accountForm: '',
      products: [],
      checkout: { lineItems: { edges: [] } },
      bundleProductHandle: window.Dormify.bundleProductHandle,
      virtualGiftCardHandle: window.Dormify.virtualGiftCardHandle,
      customCollectionId: window.Dormify.customCollectionId,
      customSliderCollectionId: window.Dormify.customSliderCollectionId,
      roomPanoCollectionId: window.Dormify.roomPanoCollectionId,
      nonPano: window.Dormify.nonPano,
      dormifyCollectionsList: window.Dormify.collectionsList,
      shipLaterEnabled: window.Dormify.shipLaterEnabled,
      pdpDiscountSnippet: window.Dormify.pdpDiscountSnippet,
      mainMenu: window.Dormify.mainMenu,
      customerLoggedIn: window.Dormify.customerLoggedIn,
      wishlistProducts: [],
      autoDiscountPromo: window.Dormify.autoDiscountPromo,
      autoDiscountCode: window.Dormify.autoDiscountCode,
      autoDiscountCodeEndDate: window.Dormify.autoDiscountCodeEndDate,
      formSubmitted: false,
      formDiscount: window.Dormify.formDiscount,
      uscDiscount: window.Dormify.uscDiscount,
      donateADollarPromo: window.Dormify.donateADollarPromo,
      donateADollarProduct: window.Dormify.donateADollarProduct,
      checkoutInitialized: false,
      showComingSoonImage: window.Dormify.showComingSoonImage,
      colorTemplate: window.Dormify.colorTemplate,
      colorSliders: window.Dormify.colorSliders,
      discountThresholdAmount: window.Dormify.discountThresholdAmount,
      donationBoxCopy: window.Dormify.donationBoxCopy,
      pdpAccordionBnslCopy: window.Dormify.pdpAccordionBnslCopy,
      pdpReturnCopy: window.Dormify.pdpReturnCopy,
      shippingTimes: window.Dormify.shippingTimes,
      lowStockThreshold: window.Dormify.lowStockThreshold,
      hideDataCaptureModal: window.Dormify.hideDataCaptureModal,
      collectionsBillboard: window.Dormify.cBillboard,
      customCollectionData: {
        customCollectionProducts: window.Dormify.customCollectionProducts,
        customCollectionSliderImgs: window.Dormify.customCollectionSliderImgs
      },
      dormifyXYouPage: window.Dormify.dormifyXYouPage,
      pdpCollectionDiscount: window.Dormify.pdpCollectionDiscount
    };

    _this.addVariantToCart = addVariantToCart.bind(_this);
    _this.updateLineItemInCart = updateLineItemInCart.bind(_this);
    _this.removeLineItemInCart = removeLineItemInCart.bind(_this);
    _this.associateCustomerCheckout = associateCustomerCheckout.bind(_this);
    _this.updateCartQuantity = updateCartQuantity.bind(_this);
    _this.addCheckoutNote = addCheckoutNote.bind(_this);
    _this.addPlusReleaseDate = addPlusReleaseDate.bind(_this);
    _this.addDiscountCode = addDiscountCode.bind(_this);
    _this.removeDiscountCode = removeDiscountCode.bind(_this);
    return _this;
  }

  _createClass(App, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      window._GlobalAddToCart = this.handleGlobalAddToCart;
      window._GlobalOpenCart = this.handleCartOpen;

      var lineItems = [];
      var note = '';
      var customAttributes = [];
      if (localStorage.dormify_checkout_items) {
        lineItems = JSON.parse(localStorage.getItem('dormify_checkout_items'));
        addLineItemsToSwym(lineItems);
      }
      if (localStorage.dormify_checkout_note) {
        note = localStorage.getItem('dormify_checkout_note');
      }
      if (localStorage.dormify_checkout_plus_release) {
        var plusReleaseObj = {
          key: 'release_date',
          value: localStorage.getItem('dormify_checkout_plus_release')
        };
        customAttributes.push(plusReleaseObj);
      }
      this.props.createCheckout({
        variables: {
          input: {
            lineItems: lineItems,
            note: note,
            customAttributes: customAttributes
          }
        }
      }).then(function (res) {
        _this2.updateCartQuantity();
        _this2.setState({
          checkout: res.data.checkoutCreate.checkout,
          checkoutInitialized: true
        }, function () {
          _this2.updateCartQuantity();
        });
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var that = this;
      var getWishlistProducts = function getWishlistProducts() {
        window._swat.fetch(function (result) {
          var wishlistProducts = result.map(function (product) {
            return product.dt;
          });
          that.setState({ wishlistProducts: wishlistProducts });
        });
      };
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(getWishlistProducts);
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        ThemeProvider,
        { theme: theme },
        React.createElement(
          StyledAppWrapper,
          null,
          React.createElement(CartBtn, {
            handleCartOpen: this.handleCartOpen,
            cartQuantity: this.state.cartQuantity
          }),
          !this.state.customerLoggedIn && React.createElement(
            Fragment,
            null,
            React.createElement(
              AccountBtn,
              {
                toggleAccountModal: this.toggleAccountModal,
                id: 'modal-login__btn',
                formType: 'LOGIN'
              },
              'Sign In'
            ),
            React.createElement(
              AccountBtn,
              {
                toggleAccountModal: this.toggleAccountModal,
                id: 'modal-register__btn',
                formType: 'REGISTER'
              },
              'Sign Up'
            )
          ),
          React.createElement(MobileHamburger, {
            isNavOpen: this.state.isNavOpen,
            toggleMobileNav: this.toggleMobileNav
          }),
          React.createElement(
            Router,
            null,
            React.createElement(
              CollectionClient,
              {
                path: '/collections',
                addVariantToCart: this.addVariantToCart,
                checkout: this.state.checkout,
                customCollectionId: this.state.customCollectionId,
                customSliderCollectionId: this.state.customSliderCollectionId,
                roomPanoCollectionId: this.state.roomPanoCollectionId,
                dormifyCollectionsList: this.state.dormifyCollectionsList
              },
              React.createElement(CollectionPage, {
                path: ':handle',
                addVariantToCart: this.addVariantToCart,
                checkout: this.state.checkout,
                customCollectionId: this.state.customCollectionId,
                customSliderCollectionId: this.state.customSliderCollectionId,
                roomPanoCollectionId: this.state.roomPanoCollectionId,
                nonPano: this.state.nonPano,
                dormifyCollectionsList: this.state.dormifyCollectionsList,
                isCartOpen: this.state.isCartOpen,
                handleCartOpen: this.handleCartOpen,
                wishlistProducts: this.state.wishlistProducts,
                mainMenu: this.state.mainMenu && this.state.mainMenu.linklist,
                toggleAccountModal: this.toggleAccountModal,
                lowStockThreshold: this.state.lowStockThreshold,
                collectionsBillboard: this.state.collectionsBillboard,
                customCollectionData: this.state.customCollectionData,
                dormifyXYouPage: this.state.dormifyXYouPage
              }),
              React.createElement(CollectionPage, {
                path: '/',
                addVariantToCart: this.addVariantToCart,
                checkout: this.state.checkout,
                customCollectionId: this.state.customCollectionId,
                roomPanoCollectionId: this.state.roomPanoCollectionId,
                dormifyCollectionsList: this.state.dormifyCollectionsList,
                isCartOpen: this.state.isCartOpen,
                handleCartOpen: this.handleCartOpen,
                wishlistProducts: this.state.wishlistProducts,
                toggleAccountModal: this.toggleAccountModal,
                showComingSoonImage: this.state.showComingSoonImage,
                collectionsBillboard: this.state.collectionsBillboard
              })
            ),
            React.createElement(ProductPage, {
              path: '/products/:handle',
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout,
              shipLaterEnabled: this.state.shipLaterEnabled,
              pdpDiscountSnippet: this.state.pdpDiscountSnippet,
              wishlistProducts: this.state.wishlistProducts,
              toggleAccountModal: this.toggleAccountModal,
              bundleProductHandle: this.state.bundleProductHandle,
              virtualGiftCardHandle: this.state.virtualGiftCardHandle,
              pdpAccordionBnslCopy: this.state.pdpAccordionBnslCopy,
              pdpReturnCopy: this.state.pdpReturnCopy,
              shippingTimes: this.state.shippingTimes,
              lowStockThreshold: this.state.lowStockThreshold,
              pdpCollectionDiscount: this.state.pdpCollectionDiscount
            }),
            React.createElement(CollectionPage, {
              path: '/products',
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout,
              customCollectionId: this.state.customCollectionId,
              roomPanoCollectionId: this.state.roomPanoCollectionId,
              dormifyCollectionsList: this.state.dormifyCollectionsList,
              isCartOpen: this.state.isCartOpen,
              handleCartOpen: this.handleCartOpen,
              wishlistProducts: this.state.wishlistProducts,
              toggleAccountModal: this.toggleAccountModal,
              lowStockThreshold: this.state.lowStockThreshold
            }),
            this.state.checkoutInitialized && React.createElement(CartPage, {
              path: '/cart',
              addVariantToCart: this.addVariantToCart,
              updateCartQuantity: this.updateCartQuantity,
              removeLineItemInCart: this.removeLineItemInCart,
              updateLineItemInCart: this.updateLineItemInCart,
              addCheckoutNote: this.addCheckoutNote,
              addPlusReleaseDate: this.addPlusReleaseDate,
              addDiscountCode: this.addDiscountCode,
              removeDiscountCode: this.removeDiscountCode,
              checkout: this.state.checkout,
              cartQuantity: this.state.cartQuantity,
              shipLaterEnabled: this.state.shipLaterEnabled,
              handleCartClose: this.handleCartClose,
              autoDiscountPromo: this.state.autoDiscountPromo,
              autoDiscountCode: this.state.autoDiscountCode,
              autoDiscountCodeEndDate: this.state.autoDiscountCodeEndDate,
              donateADollarPromo: this.state.donateADollarPromo,
              donateADollarProduct: this.state.donateADollarProduct,
              discountThresholdAmount: this.state.discountThresholdAmount
            }),
            React.createElement(VisualizerClient, {
              path: '/pages/visualizer',
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout,
              toggleAccountModal: this.toggleAccountModal
            }),
            React.createElement(VisualizerClient, {
              path: '/pages/wall-visualizer',
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout,
              toggleAccountModal: this.toggleAccountModal
            }),
            React.createElement(DyPage, {
              path: '/pages/tiktok',
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout,
              dySlug: 'tiktok',
              sliderId: 'tiktok-dy-slider'
            }),
            React.createElement(DyPage, {
              path: '/pages/home-and-apt',
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout,
              dySlug: 'apt-slider',
              sliderId: 'apt-dy-slider'
            }),
            React.createElement(DyPage, {
              path: '/pages/usc',
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout,
              dySlug: 'usc-slider',
              sliderId: 'usc-dy-slider'
            }),
            React.createElement(SliderPage, {
              path: '/pages/dormify-collaborations',
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout,
              sliderId: 'hub-product-slider',
              sliderCollection: 'dormify-x-artsugar'
            }),
            React.createElement(SliderPage, {
              path: '/pages/burrow-small-space-sofa',
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout,
              sliderId: 'burrow-launch-slider',
              sliderCollection: 'sofas'
            }),
            React.createElement(SliderPage, {
              path: '/pages/tomorrow-sleep-mattress',
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout,
              sliderId: 'tomorrow-sleep-launch-slider',
              sliderCollection: 'tomorrow-sleep'
            }),
            React.createElement(HomePage, {
              path: '/',
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout
            }),
            React.createElement(HolidayPage, {
              path: '/collections/gifts',
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout
            }),
            React.createElement(ColorPage, {
              path: '/pages/the-pink-shop',
              colorTemplate: this.state.colorTemplate,
              colorSliders: this.state.colorSliders,
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout
            }),
            React.createElement(ColorPage, {
              path: '/pages/the-blue-shop',
              colorTemplate: this.state.colorTemplate,
              colorSliders: this.state.colorSliders,
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout
            }),
            React.createElement(ColorPage, {
              path: '/pages/the-green-shop',
              colorTemplate: this.state.colorTemplate,
              colorSliders: this.state.colorSliders,
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout
            }),
            React.createElement(ColorPage, {
              path: '/pages/the-natural-shop',
              colorTemplate: this.state.colorTemplate,
              colorSliders: this.state.colorSliders,
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout
            }),
            React.createElement(ColorPage, {
              path: '/pages/the-grey-shop',
              colorTemplate: this.state.colorTemplate,
              colorSliders: this.state.colorSliders,
              addVariantToCart: this.addVariantToCart,
              checkout: this.state.checkout
            }),
            React.createElement(DataCapturePage, {
              path: '/pages/sign-up',
              handleFormSubmitDiscountCode: this.handleFormSubmitDiscountCode,
              formDiscount: this.state.formDiscount
            }),
            React.createElement(AccountVisualizerClient, {
              path: '/account',
              addVariantToCart: this.addVariantToCart
            }),
            React.createElement(Account, {
              path: '/account/login',
              formType: this.state.accountForm !== '' ? this.state.accountForm : 'LOGIN',
              toggleAccountForm: this.toggleAccountForm
            }),
            React.createElement(Account, {
              path: '/account/register',
              formType: this.state.accountForm !== '' ? this.state.accountForm : 'REGISTER',
              toggleAccountForm: this.toggleAccountForm
            })
          ),
          this.state.checkoutInitialized && React.createElement(CartDrawerAlt, {
            addVariantToCart: this.addVariantToCart,
            updateCartQuantity: this.updateCartQuantity,
            removeLineItemInCart: this.removeLineItemInCart,
            updateLineItemInCart: this.updateLineItemInCart,
            addCheckoutNote: this.addCheckoutNote,
            addPlusReleaseDate: this.addPlusReleaseDate,
            addDiscountCode: this.addDiscountCode,
            removeDiscountCode: this.removeDiscountCode,
            checkout: this.state.checkout,
            isCartOpen: this.state.isCartOpen,
            cartQuantity: this.state.cartQuantity,
            shipLaterEnabled: this.state.shipLaterEnabled,
            handleCartClose: this.handleCartClose,
            autoDiscountPromo: this.state.autoDiscountPromo,
            autoDiscountCode: this.state.autoDiscountCode,
            formSubmitted: this.state.formSubmitted,
            formDiscountCode: this.state.formOrigin === 'usc' // Applying code after submission from USC Data Capture Modal
            ? this.state.uscDiscount.code : this.state.formDiscount.code,
            autoDiscountCodeEndDate: this.state.autoDiscountCodeEndDate,
            donateADollarPromo: this.state.donateADollarPromo,
            donateADollarProduct: this.state.donateADollarProduct,
            discountThresholdAmount: this.state.discountThresholdAmount,
            donationBoxCopy: this.state.donationBoxCopy,
            shippingTimes: this.state.shippingTimes
          }),
          React.createElement(MobileNav, {
            isNavOpen: this.state.isNavOpen,
            mainMenu: this.state.mainMenu,
            toggleMobileNav: this.toggleMobileNav,
            customerLoggedIn: this.state.customerLoggedIn,
            toggleAccountModal: this.toggleAccountModal
          }),
          React.createElement(CloseButton, {
            onClick: this.handleCartClose,
            visible: this.state.isCartOpen,
            btnType: 'Cart',
            'aria-label': 'Close Cart'
          }),
          React.createElement(DataCaptureModal, {
            handleFormSubmitDiscountCode: this.handleFormSubmitDiscountCode,
            formDiscount: this.state.formDiscount,
            hideDataCaptureModal: this.state.hideDataCaptureModal
          }),
          React.createElement(UscDataCaptureModal, {
            handleFormSubmitDiscountCode: this.handleFormSubmitDiscountCode,
            formDiscount: this.state.uscDiscount
          }),
          React.createElement(AccountModal, {
            isAccountModalOpen: this.state.isAccountModalOpen,
            formType: this.state.accountForm,
            toggleAccountModal: this.toggleAccountModal,
            toggleAccountForm: this.toggleAccountForm
          }),
          React.createElement(FooterForm, {
            handleFormSubmitDiscountCode: this.handleFormSubmitDiscountCode,
            formDiscount: this.state.formDiscount
          })
        )
      );
    }
  }]);

  return App;
}(Component);

App.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    error: PropTypes.object,
    shop: PropTypes.object
  }).isRequired,
  createCheckout: PropTypes.func.isRequired,
  checkoutLineItemsReplace: PropTypes.func.isRequired,
  checkoutLineItemsUpdate: PropTypes.func.isRequired,
  checkoutLineItemsRemove: PropTypes.func.isRequired,
  checkoutCustomerAssociate: PropTypes.func.isRequired,
  checkoutAttributesUpdateV2: PropTypes.func.isRequired
};

var query = gql(_templateObject2);

var AppWithDataAndMutation = compose(graphql(query), graphql(createCheckout, { name: 'createCheckout' }), graphql(checkoutLineItemsReplace, { name: 'checkoutLineItemsReplace' }), graphql(checkoutLineItemsUpdate, { name: 'checkoutLineItemsUpdate' }), graphql(checkoutLineItemsRemove, { name: 'checkoutLineItemsRemove' }), graphql(checkoutCustomerAssociate, { name: 'checkoutCustomerAssociate' }), graphql(checkoutAttributesUpdateV2, { name: 'checkoutAttributesUpdateV2' }), graphql(checkoutDiscountCodeApplyV2, { name: 'checkoutDiscountCodeApplyV2' }), graphql(checkoutDiscountCodeRemove, { name: 'checkoutDiscountCodeRemove' }))(App);

export default AppWithDataAndMutation;